// extracted by mini-css-extract-plugin
module.exports = {"AddToCartBtn":"AddToCartIcon_AddToCartBtn__2lsM1"};